import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useMemo, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  companyToUserLockUser,
  companyToUserLockUserSuccess,
  companyToUserUnlockUser,
  companyToUserUnlockUserSuccess,
  deleteCompanyToUser,
  deleteCompanyToUserSuccess,
  getCompanyToUserData,
  getCompanyToUserListTeam,
  sendEmailInvitation,
} from "../../../../store/companyToUser/action";
import { toast } from "react-toastify";
import { isEmpty } from "lodash";

import "../../settings.styles.css";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Row,
  UncontrolledDropdown,
} from "reactstrap";

import TableContainer from "../../../../Components/Common/TableContainer";
import NoDataContent from "../../../../Components/Common/NoDataContent";

import CreateEditCompanyUserLicenses from "../../../../Components/popUpComponents/CreateEditCompanyUserLicenses";

import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";

import handleDateTimeLeft from "../../../../Components/Common/HandleDateTimeLeft";
import DeleteModal from "../../../../Components/Common/DeleteModal";
import LoadingSpinner from "../../../../Components/Common/Spinner";
import HandleDateTime, {
  HandleDate,
} from "../../../../Components/Common/HandleDateTime";
import SettingsPanel from "../../components/SettingsPanel";

export const UserInvitation = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getCompanyToUserListTeam());
  }, []);

  const { companyUserInvitationsAPI, getCompanyToUserListTeamLoading } =
    useSelector((state) => ({
      companyUserInvitationsAPI:
        state.CompanyToUser.getCompanyToUserListTeam?.companytouser_list,
      getCompanyToUserListTeamLoading:
        state.CompanyToUser.getCompanyToUserListTeamLoading,
    }));
  console.log("companyUserInvitationsAPI", companyUserInvitationsAPI);

  const [searchResults, setSearchResults] = useState([]);

  const [searchQuery, setSearchQuery] = useState("");
  const [allowedSearchFilters, setAllowedSearchFilters] = useState([
    "InvitedByUser_DisplayName",
    "Id",
    "User_Id",
    "User_UserFullName",
    "User_Email",
  ]);

  const columns = useMemo(
    () => [
      {
        // job id with beginning #Job_Id
        Header: "Id",
        accessor: "CompanyToUser_Id",
        filterable: false,
        Cell: (row) => (
          <>
            <div className="d-flex align-items-center">
              <div className="d-flex ">
                {row.row.original?.CompanyToUser_UserLockedFlag === "1" ? (
                  <span className={"text-danger me-2"}>
                    <i className="fa-solid fa-lock"></i>
                  </span>
                ) : (
                  <span className={"text-success me-2"}>
                    <i className="fa-solid fa-lock"></i>
                  </span>
                )}
                <span> #{row.row.original?.CompanyToUser_Id}</span>
              </div>
            </div>
          </>
        ),
      },

      {
        Header: "Full Name",
        accessor: "User_UserFullName",
        filterable: true,
        Cell: (loyalty) => (
          <>
            <div className={"py-2"}>
              <span className={"fw-semibold"}>
                {loyalty.row.original?.User_UserFullName}
              </span>
            </div>
            <div>
              {!isEmpty(loyalty.row.original?.subscriptionlicence_list) && (
                <div>
                  {/*<div>*/}
                  {/*  <span>Subscriptions</span>*/}
                  {/*  {loyalty.row.original?.subscriptionlicence_list.map(*/}
                  {/*    (subscriptionLicenseItem, index) => (*/}
                  {/*      <div key={index} className={"pb-1"}>*/}
                  {/*        <div>*/}
                  {/*          <span className={"badge badge-soft-primary"}>*/}
                  {/*            {subscriptionLicenseItem?.SubscriptionProduct_Name +*/}
                  {/*              " £" +*/}
                  {/*              subscriptionLicenseItem?.SubscriptionLicence_AmountLocalTotal}*/}

                  {/*            {subscriptionLicenseItem?.SubscriptionLicence_RenewalDateTime && (*/}
                  {/*              <span className={"ms-1 "}>*/}
                  {/*                Expires in:{" "}*/}
                  {/*                {handleDateTimeLeft(*/}
                  {/*                  subscriptionLicenseItem?.SubscriptionLicence_RenewalDateTime*/}
                  {/*                )}*/}
                  {/*              </span>*/}
                  {/*            )}*/}
                  {/*          </span>*/}
                  {/*        </div>*/}
                  {/*      </div>*/}
                  {/*    )*/}
                  {/*  )}*/}
                  {/*</div>*/}
                  {/*<div>*/}
                  {/*  <span>Security Roles</span>*/}
                  {/*  {loyalty.row.original?.securityauthrole_list.map(*/}
                  {/*    (subscriptionLicenseItem, index) => (*/}
                  {/*      <div key={index} className={"pb-1"}>*/}
                  {/*        <div>*/}
                  {/*          <span className={"badge badge-soft-primary"}>*/}
                  {/*            {subscriptionLicenseItem?.SecurityAuthRole_Name}*/}
                  {/*          </span>*/}
                  {/*        </div>*/}
                  {/*      </div>*/}
                  {/*    )*/}
                  {/*  )}*/}
                  {/*</div>*/}
                </div>
              )}
            </div>
          </>
        ),
      },

      {
        Header: "License",
        accessor: "subscriptionlicence_list",
        filterable: true,
        Cell: (loyalty) => (
          <>
            <div>
              {loyalty.row.original?.subscriptionlicence_list.map(
                (subscriptionLicenseItem, index) => (
                  <div key={index} className={"pb-1"}>
                    <div>
                      <span className={"badge badge-soft-primary"}>
                        {subscriptionLicenseItem?.SubscriptionProduct_Name +
                          " £" +
                          subscriptionLicenseItem?.SubscriptionLicence_AmountLocalTotal}

                        {subscriptionLicenseItem?.SubscriptionLicence_RenewalDateTime && (
                          <span className={"ms-1 "}>
                            Expires in:{" "}
                            {handleDateTimeLeft(
                              subscriptionLicenseItem?.SubscriptionLicence_RenewalDateTime
                            )}
                          </span>
                        )}
                      </span>
                    </div>
                  </div>
                )
              )}
            </div>
          </>
        ),
      },
      {
        Header: "Security Roles",
        accessor: "securityauthrole_list",
        filterable: true,
        Cell: (loyalty) => (
          <>
            <div>
              {loyalty.row.original?.securityauthrole_list.map(
                (subscriptionLicenseItem, index) => (
                  <div key={index} className={"pb-1"}>
                    <div>
                      <span className={"badge badge-soft-secondary"}>
                        {subscriptionLicenseItem?.SecurityAuthRole_Name}
                      </span>
                    </div>
                  </div>
                )
              )}
            </div>
          </>
        ),
      },
      {
        Header: "Date Locked",
        accessor: "CompanyToUser_LockedDateTime",
        Cell: (user) => (
          <div>
            {HandleDateTime(
              user.row.original?.CompanyToUser_UserLockedDateTime
            )}
          </div>
        ),
        filterable: true,
      },
      {
        Header: "Email",
        accessor: "User_Email",
        filterable: true,
        Cell: (loyalty) => (
          <>
            <div>{loyalty.row.original?.User_Email}</div>
          </>
        ),
      },

      {
        Header: "Action",
        Cell: (cellProps) => {
          return (
            <UncontrolledDropdown>
              <DropdownToggle
                className="btn btn-soft-info btn-icon fs-14"
                type="button"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="fa-solid fa-ellipsis"></i>
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem
                  onClick={() => {
                    handleLockUser(
                      cellProps.row.original?.User_Id,
                      cellProps.row.original?.CompanyToUser_Id
                    );
                  }}
                >
                  <i className="fa-solid fa-lock me-1 text-muted"></i>
                  Lock
                </DropdownItem>
                <DropdownItem
                  onClick={() => {
                    handleUnlockUser(
                      cellProps.row.original?.User_Id,
                      cellProps.row.original?.CompanyToUser_Id
                    );
                  }}
                >
                  <i className="fa-solid fa-lock-open me-1 text-muted"></i>
                  Unlock
                </DropdownItem>
                <DropdownItem
                  onClick={() => {
                    handleGetUserData(cellProps.row.original?.CompanyToUser_Id);
                  }}
                >
                  <i className="fa-solid fa-user-pen me-1 text-muted"></i>Edit
                </DropdownItem>

                <DropdownItem
                  onClick={() => {
                    setDeleteUser(cellProps.row.original?.Id);
                    setDeleteUserModal(true);
                  }}
                >
                  <div className={"d-flex align-items-center"}>
                    <i className="fa-solid fa-user-minus me-1 text-danger"></i>
                    Delete
                  </div>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          );
        },
      },
    ],
    []
  );

  const [deleteUser, setDeleteUser] = useState(null);
  const [deleteUserModal, setDeleteUserModal] = useState(false);
  const toggleDeleteUserModal = () => setDeleteUserModal(!deleteUserModal);

  useEffect(() => {
    if (isEmpty(companyUserInvitationsAPI)) return;
    let filteredData = companyUserInvitationsAPI;
    const timer = setTimeout(() => {
      // check if filter is empty or not
      filteredData = filteredData.filter((item) => {
        return allowedSearchFilters.some((key) => {
          return (
            item[key] &&
            item[key]
              ?.toString()
              ?.toLowerCase()
              ?.includes(searchQuery?.toLowerCase())
          );
        });
      });

      setSearchResults(filteredData);
    }, 300);
    return () => clearTimeout(timer);
  }, [searchQuery, companyUserInvitationsAPI]);

  const localAuthUserFlagDeveloper =
    JSON.parse(localStorage.getItem("authUser"))?.get_user_data
      ?.User_FlagDeveloper === "1";

  const localAuthRole100 = JSON.parse(
    localStorage.getItem("authUser")
  )?.get_securityauthrole_list?.some(
    (item) => item.SecurityAuthRole_Id === "100"
  );
  console.log("localAuthRole100", localAuthRole100);

  const [modalUserCreateEdit, setModalUserCreateEdit] = useState(false);
  const toggleUserCreateEdit = () =>
    setModalUserCreateEdit(!modalUserCreateEdit);
  const [isEdit, setIsEdit] = useState(false);

  const handleDeleteSingleRecord = () => {
    dispatch(deleteCompanyToUser([deleteUser]));
  };

  const { DeleteSUCCESS } = useSelector((state) => ({
    DeleteSUCCESS: state.CompanyToUser.deleteCompanyToUserSuccess,
  }));
  useEffect(() => {
    if (isEmpty(DeleteSUCCESS)) return;
    if (DeleteSUCCESS.status === 200) {
      toast.success(DeleteSUCCESS.message);
      setDeleteUserModal(false);
      dispatch(getCompanyToUserListTeam());
    } else {
      toast.error(DeleteSUCCESS.message);
    }
    dispatch(deleteCompanyToUserSuccess({}));
  }, [DeleteSUCCESS]);

  const handleLockUser = (userId, companyToUserId) => {
    dispatch(
      companyToUserLockUser([
        {
          CompanyToUser_Id: companyToUserId,
          User_Id: userId,
        },
      ])
    );
  };
  const handleUnlockUser = (userId, companyToUserId) => {
    dispatch(
      companyToUserUnlockUser([
        {
          CompanyToUser_Id: companyToUserId,
          User_Id: userId,
        },
      ])
    );
  };
  const { companyToUserLockUserAPI, companyToUserUnlockUserAPI } = useSelector(
    (state) => ({
      companyToUserLockUserAPI: state.CompanyToUser.companyToUserLockUser,
      companyToUserUnlockUserAPI: state.CompanyToUser.companyToUserUnlockUser,
    })
  );

  // lockUser Success
  useEffect(() => {
    if (isEmpty(companyToUserLockUserAPI)) return;
    if (companyToUserLockUserAPI.status === 200) {
      toast.success(companyToUserLockUserAPI.message);
      dispatch(getCompanyToUserListTeam());
    } else {
      toast.error(companyToUserLockUserAPI.message);
    }
    dispatch(companyToUserLockUserSuccess({}));
  }, [companyToUserLockUserAPI]);

  // unlockUser Success
  useEffect(() => {
    if (isEmpty(companyToUserUnlockUserAPI)) return;
    if (companyToUserUnlockUserAPI.status === 200) {
      toast.success(companyToUserUnlockUserAPI.message);
      dispatch(getCompanyToUserListTeam());
    } else {
      toast.error(companyToUserUnlockUserAPI.message);
    }
    dispatch(companyToUserUnlockUserSuccess({}));
  }, [companyToUserUnlockUserAPI]);

  const handleGetUserData = (id) => {
    dispatch(getCompanyToUserData({ id }));
    setIsEdit(true);
    setModalUserCreateEdit(true);
  };

  const { companyToUserDataAPI } = useSelector((state) => ({
    companyToUserDataAPI:
      state.CompanyToUser.companyToUserData?.companytouser_data,
  }));

  return (
    <div>
      {deleteUserModal && (
        <DeleteModal
          show={deleteUserModal}
          onCloseClick={() => {
            setDeleteUserModal(false);
          }}
          onDeleteClick={() => {
            handleDeleteSingleRecord();
          }}
          customText={"Are you sure you want to delete this User?"}
          customButtonText={"Yes, Delete It!"}
        />
      )}
      {modalUserCreateEdit && (
        <CreateEditCompanyUserLicenses
          updateData={companyToUserDataAPI}
          toggle={toggleUserCreateEdit}
          modal={modalUserCreateEdit}
          setModal={setModalUserCreateEdit}
          isEdit={isEdit}
        />
      )}
      {localAuthRole100 ? (
        <SettingsPanel
          title="User Invitation"
          description="Invite people and assign them licences"
        >
          <div>
            <Row>
              <Col lg={12}>
                <Card>
                  <CardHeader className="border-0">
                    <Row className="g-4 align-items-center">
                      <Col sm={3}>
                        <div className="search-box">
                          <Input
                            // create search with jobs List Data
                            type="search"
                            className="form-control search"
                            placeholder="Search for..."
                            onChange={(e) => {
                              setSearchQuery(e.target.value);
                            }}
                            value={searchQuery}
                          />
                          <i className="ri-search-line search-icon"></i>
                        </div>
                      </Col>
                      <Col sm={9}>
                        <div className={"d-flex justify-content-end"}>
                          <button
                            className={
                              "btn btn-success  send-user-invitation-email-button"
                            }
                            onClick={() => {
                              setModalUserCreateEdit(true);
                              setIsEdit(false);
                            }}
                          >
                            Add New User
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </CardHeader>
                  <CardBody className="pt-0 d-flex overflow-auto">
                    {getCompanyToUserListTeamLoading ? (
                      <LoadingSpinner />
                    ) : (
                      <div>
                        {!isEmpty(searchResults) ? (
                          <TableContainer
                            columns={columns}
                            data={searchResults || []}
                            isGlobalFilter={false}
                            isAddUserList={false}
                            customPageSize={10}
                            className="custom-header-css"
                            divClass="table-responsive table-card mb-0"
                            tableClass="align-middle table-wrap"
                            theadClass="text-muted"
                            // handleLeadClick={handleLeadClicks}
                            isLeadsFilter={false}
                          />
                        ) : (
                          <>
                            <div>
                              <NoDataContent
                                titleText={`No Data Found`}
                                paragraphText={`Try new search query no data found or Add new User`}
                                useButton={false}
                              />
                            </div>
                          </>
                        )}
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </SettingsPanel>
      ) : (
        <div className={"p-4"}>
          <div className={"d-flex justify-content-center"}>
            <div>
              <h2>Sorry looks like you dont have access to user invitation </h2>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
